const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:9000/api/v1';
/** Backend origin for resolving media URLs (e.g. /media/...) */
export const BACKEND_URL = API_BASE.replace(/\/api\/v1\/?$/, '');

const TOKEN_KEY = 'auth_token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export async function apiFetch<T>(
  endpoint: string,
  options?: RequestInit
): Promise<T> {
  const url = `${API_BASE}${endpoint}`;
  const token = getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options?.headers as Record<string, string>),
  };
  if (token) {
    headers['Authorization'] = `Token ${token}`;
  }
  const response = await fetch(url, {
    ...options,
    headers,
  });
  if (!response.ok) {
    let body: any = null;
    try { body = await response.json(); } catch { /* no json body */ }
    const err: any = new Error(body?.detail || `API error: ${response.status}`);
    err.status = response.status;
    err.body = body;
    throw err;
  }
  if (response.status === 204) {
    return undefined as T;
  }
  return response.json();
}

/** Multipart upload — same auth, but no Content-Type (browser sets boundary). */
export async function apiUpload<T = void>(
  endpoint: string,
  formData: FormData,
  method: 'POST' | 'PATCH' = 'POST'
): Promise<T> {
  const url = `${API_BASE}${endpoint}`;
  const token = getToken();
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Token ${token}`;
  }
  const response = await fetch(url, { method, headers, body: formData });
  if (!response.ok) {
    let body: any = null;
    try { body = await response.json(); } catch { /* no json body */ }
    const err: any = new Error(body?.detail || `API error: ${response.status}`);
    err.status = response.status;
    err.body = body;
    throw err;
  }
  if (response.status === 204) {
    return undefined as T;
  }
  return response.json();
}
